import CryptoJS from 'crypto-js'
import VueElementLoading from 'vue-element-loading'
import PageTracker from '../../../common/PageTrackerHelper.js'
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper.js";
import dummyInput from '../common/smartInput.vue'
import { onePageVarifyAwbAndFlyer} from "../../../../services/modules/printlabelservices.js";

export default {
    name: 'Verify AWB and Flyer',
    components: {
        VueElementLoading,
        CryptoJS,
        'dummy-input': dummyInput
    },
    mixins: [PageTracker],
    data() {
        return {
            hubid: null,
            shipmentBarcode: '',
            flyerBarcode: '',

            /* User details Params */
            outsourcingid: '',
            userrole: '',
            localusermailid: '',
            hubid: '',
            userid: '',
            localuserEmail: '',
            userDataKey:'',
            isShowDummyInput: false,
            styleData: {},
            dummyInputTimeout: 20000,
        }
    },
    watch: {
        shipmentBarcode: createClearInputWatcher('shipmentBarcode'),
    },  
    async mounted() {
        this.userDataKey = window.localStorage.getItem('userUniqueKey');
        // let validateUser = await this.validateJwtToken();
        var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.userrole = userdetail.userrole[0].rolename;
        this.userid = userdetail.userid
        this.localusermailid = userdetail.username;
        this.hubid = userdetail.hubdetails[0]
        this.outsourcingid = userdetail.outsourcingid
        this.localuserEmail = userdetail.email;

    },
    methods: {

        /* Inscan Shipment */
        submitForm(scope) {
            this.isShowDummyInput = false;
            this.$validator.validateAll(scope).then(res => {
                if (res) {
                    let inscan_payload = {
                        "shippingId": this.shipmentBarcode.toString(),
                        "flyerBarcode": this.flyerBarcode,
                        "requestedBy":this.localusermailid
                    }

                    onePageVarifyAwbAndFlyer(inscan_payload, (result) => {
                    //console.log("---result-"+JSON.stringify(result)); 
                        this.isShowDummyInput = true;
                        this.styleData = result.data.lossCategorization;
           
                        try {
                            if (result.data.code == 200) {
                                this.$alertify.success(result.data.message)
                            } else {
                                this.$alertify.error(result.data.message)
                            }
                        } catch (error) {
                            console.log("----" + error.message);
                        }
                    })
                }
            }).catch(() => {
                console.log('errors exist', this.errors)
              });
        },
        reset(){
            this.shipmentBarcode = "";
            this.flyerBarcode = "";
            this.isShowDummyInput = false;
            this.$refs.dummyShipInputBox.clearStyles();
        }
    }
}




// WEBPACK FOOTER //
// ./src/views/components/RVPVerifyAwbAndFlyer/RVPVerifyAwbAndFlyer.component.js